import { queryPremiumRateForWPEIP85 as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForWPEIP85 as calculateRiderPremium } from 'core/service/rider/premium-calculation'

export default {
  calculateRiderPremium,
  queryPremiumRate,
}
